import { Hidden }                                    from "@material-ui/core";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector }                  from "react-redux";
import { Button, Dropdown, Icon, Modal }             from "semantic-ui-react";
import GetStaffOnAccount                             from "../../../application/usecase/staff/GetStaffOnAccount";
import UpdateStaffOnAccount                          from "../../../application/usecase/staff/UpdateStaffOnAccount";
import Account                                       from "../../../domain/account/Account";
import Staff                                         from "../../../domain/staff/Staff";
import StaffRepository                               from "../../../domain/staff/StaffRepository";
import { ResKaState }                                from "../../../index";
import StaffDataSource                               from "../../../infrastructure/datasource/staff/StaffDataSource";
import StaffAccountEditForm                          from "./StaffAccountEditForm";

const StaffInfo: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const getStaffOnAccount: GetStaffOnAccount = new GetStaffOnAccount(useDispatch());
  const repository: StaffRepository = new StaffDataSource(useDispatch());
  const updateStaffOnAccount: UpdateStaffOnAccount = new UpdateStaffOnAccount(useDispatch());
  const updateTarget: Staff = useSelector((state: ResKaState) => state.staff);
  const [staff, setStaff] = useState(new Staff());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (account.role.isStaff()) {
      getStaffOnAccount.execute(setStaff);
    }
  }, [account, updateTarget]);

  if (!account.role.isStaff()) return null;

  const trigger: ReactNode = (
    <>
      <Hidden smDown>
        <span>
          <Icon name="user circle" size="large"/>
          { `ようこそ ${ staff.name.lastName.value } ${ staff.name.firstName.value } さん` }
        </span>
      </Hidden>

      <Hidden mdUp>
        <span>
          <Icon name="user circle" size="large"/>
        </span>
      </Hidden>
    </>
  );

  return (
    <>
      <Dropdown trigger={ trigger }>
        <Dropdown.Menu>
          <Dropdown.Item
            text="自分の情報を編集"
            onClick={ () => {
              repository.setStaff(staff);
              setOpen(true);
            } }
          />
        </Dropdown.Menu>
      </Dropdown>

      <Modal open={ open }>
        <Modal.Header>自分の情報を編集</Modal.Header>
        <Modal.Content>
          <StaffAccountEditForm/>
        </Modal.Content>
        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            positive
            onClick={ () => updateStaffOnAccount.execute(updateTarget, setOpen) }
          >
            <Icon name="save"/>
            保存する
          </Button>

          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default StaffInfo;
